import { useColorModeValue } from '@chakra-ui/react';

/** Shared blank-flag palette for TBD teams (fixtures, team cards, knockout nodes). */
export function useTbdFlagStyle() {
  return {
    bg: useColorModeValue('surfaceInset', 'white'),
    borderColor: useColorModeValue('homeBorder', 'whiteAlpha.300'),
    opacity: useColorModeValue(1, 0.72),
  };
}
